import { styled } from '@openeducation/oe-rn-themes';
import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

import { LevelBadgeSvg } from './level-badge-svg';
import { OEText } from '../../atoms';
import { flex } from '../../style-utils';

export interface LevelBadgeProps {
  level: number;
  size?: number;
  containerStyle?: StyleProp<ViewStyle>;
}

export const LevelBadge = ({
  level,
  size = 125,
  containerStyle,
}: LevelBadgeProps) => {
  const levelFontSize = (size * 43) / 100;

  return (
    <View
      style={[
        flex('align-items-center', 'justify-content-center'),
        containerStyle,
      ]}
    >
      <LevelBadgeSvg size={size} />

      <Level color="white" fontType="bold" fontSize={levelFontSize}>
        {level}
      </Level>
    </View>
  );
};

const Level = styled(OEText)`
  position: absolute;
  margin-top: 5px;
  z-index: 1000;
`;
